import { Button } from '@factorialco/deprecated-design-system'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

interface Props {
  id: number
  catalog: boolean
  status?: string | null
}

export const ActionsDropdown = ({ id, catalog, status }: Props) => {
  const { navigation } = useNavigation()

  const title = catalog ? i18n.t('trainings.catalog_remove') : i18n.t('trainings.catalog_display')

  return (
    <PopoverMenu type="list">
      <PopoverMenu.Trigger>
        <Button type="secondary" iconName="ellipsis" />
      </PopoverMenu.Trigger>
      <PopoverMenu.Content side="bottom" align="end">
        <>
          <PopoverMenu.RouterOption
            title={i18n.t('trainings.trainings_table.duplicate')}
            onClick={() => track(trackingEvents.training.duplicate.goToDuplicateCourse)}
            to={{ pathname: navigation.trainings.list.index.duplicate.fullPath({ id: id }) }}
          />
          {status != 'draft' && (
            <PopoverMenu.RouterOption
              title={title}
              to={{ pathname: navigation.trainings.list.index.updateCatalog.fullPath({ id: id }) }}
            />
          )}
          <PopoverMenu.RouterOption
            title={i18n.t('trainings.trainings_table.delete')}
            to={{ pathname: navigation.trainings.list.index.delete.fullPath({ id: id }) }}
            danger
          />
        </>
      </PopoverMenu.Content>
    </PopoverMenu>
  )
}
